import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { sepolia, hardhat } from 'wagmi/chains';

// 合约地址（部署后需要更新）
export const CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS || '';

// 支持的链（主要使用 Sepolia 测试网）
const chains = [sepolia, hardhat] as const;

// RainbowKit 配置
// 注意：如果没有 WalletConnect Project ID，可以使用临时 ID（仅用于开发）
// 生产环境建议从 https://cloud.walletconnect.com/ 获取 Project ID
export const wagmiConfig = getDefaultConfig({
  appName: '链上抢红包系统',
  projectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '00000000000000000000000000000000',
  chains: chains as any,
  ssr: false, // 如果不是 SSR，设置为 false
});

